import { render } from "./OperarioCodigosPostales.vue?vue&type=template&id=36fcbcc7"
import script from "./OperarioCodigosPostales.vue?vue&type=script&lang=js"
export * from "./OperarioCodigosPostales.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__